// ============================================================================
// FLOYD-WARSHALL - ALGORITHM METADATA
// ============================================================================

export const meta = {
  id: 'floyd-warshall',
  name: 'Floyd-Warshall',
  category: 'Graphs',
  complexity: {
    time: 'O(V³)',
    space: 'O(V²)'
  },
  description: 'An all-pairs shortest path algorithm that finds shortest paths between all pairs of vertices in a weighted graph. It uses dynamic programming and can handle negative edge weights (but not negative cycles).'
};
